<template>
  <div class="manager-management">
    <div class="page-search-block">
      <div class="m-b-18">
        <span class="w-90 inline-block align-r m-r-8">经营者状态：</span>
        <div class="buttons-wrapper">
          <el-button
            v-for="item in managerStatusList"
            :key="item.name"
            :class="curActiveStatus == item.name ? 'primary' : 'info'"
            class="search-field-btn"
            @click="handleSearchStatus(item.name)"
          >
            {{ item.label }}
          </el-button>
        </div>
      </div>
      <div class="m-b-18">
        <span class="w-90 inline-block align-r m-r-8">经营类别：</span>
        <div class="buttons-wrapper">
          <el-button
            v-for="item in managerTypeList"
            :key="item.id"
            :class="curActiveType == item.id ? 'primary' : 'info'"
            class="search-field-btn"
            @click="handleSearchType(item.id)"
          >
            {{ item.label }}
          </el-button>
        </div>
      </div>
      <div class="search-bar">
        <!-- <span class="w-90 inline-block align-r m-r-8">高级筛选：</span> -->
        <el-select class="select-as-label m-r-8 w-120" v-model="searchKey">
          <el-option label="经营人" value="realManagerName"></el-option>
          <el-option label="经营者编码" value="managerCode"></el-option>
        </el-select>
        <el-input
          class="w-200 m-r-8"
          v-model="searchValue"
          placeholder="请输入"
        ></el-input>
        <el-button
          class="submit-btn"
          type="warning"
          @click="handleSearch"
          >搜 索</el-button
        >
      </div>
    </div>
    <div class="page-operate-block">
      <div class="tit"></div>
      <div>
        <i
          class="fa icon-eye"
          :class="[hiddenNumberBol ? 'fa-eye-slash' : 'fa-eye']"
          @click="switchNumberHiddenOrShow()"
        ></i>
        <el-popover placement="bottom" trigger="click" popper-class="r-popover">
          <el-checkbox
            :indeterminate="isIndeterminate"
            v-model="checkAll"
            @change="handleCheckAllChange"
            >全选</el-checkbox
          >
          <br />
          <el-checkbox
            v-for="(column, index) in tableColumn"
            v-model="column.visible"
            :key="index"
            @change="_checkChange"
            >{{ column.label }}</el-checkbox
          >
          <template #reference>
            <el-button
              class="operate-button"
              name="dataSetting"
              type="warning"
              plain
              >数据项</el-button
            >
          </template>
        </el-popover>
        <el-button
            v-permission="'add'"
            name="dataSetting"
            class="primary-btn-g m-r-xs"
            icon="Plus"
            size="small"
            @click="handleEdit('add')"
            >新增</el-button
          >
          <el-button
            v-permission="'edit'"
            name="dataSetting"
            :disabled="options.selection.length != 1"
            class="primary-btn-g m-r-xs"
            icon="Edit"
            size="small"
            @click="handleEdit('edit')"
            >编辑</el-button
          >
        <el-button
          v-permission="'audit'"
          :disabled="options.selection.length != 1"
          v-if="curActiveStatus == 1"
          class="operate-btn"
          @click="handleShowCheck"
          >审核</el-button
        >
        <el-button
          v-permission="'cancel'"
          :disabled="options.selection.length < 1"
          class="operate-btn"
          @click="handleCancled"
          >注销</el-button
        >
        <el-button
          v-permission="'delete'"
          :disabled="options.selection.length < 1"
          class="operate-btn"
          @click="handleDelete"
          >删除</el-button
        >
      </div>
    </div>

    <div class="table-list-block">
      <r-table
        :ref="tableVarity"
        :columns="tableColumn"
        :dataSource="tableData"
        :options="options"
        :pagination="pagination"
        @current-change="handlePageChange"
        @row-click="handleRowClick"
      ></r-table>
    </div>
    <!--查看-->
    <RModal
      customClass="manager-modal bigModalDialog"
      :title="detailType == 'check' ? '审核' : '详情'"
      top="5vh"
      :show="detailModal"
      :closeOnClick="false"
      :width="'60%'"
      @change="detailModal = false"
      @close="closeModel"
    >
      <template #content>
        <detail-view
          v-if="detailType == 'show'"
          :detail-modal="detailModal"
          :detail-data="detailData"
          :is-encry="hiddenNumberBol"
          :encry-list="encryList"
          :encry-func="encryData"
          @closeModel="closeModel"
        ></detail-view>
        <edit-view
          v-else-if="detailType == 'add' || detailType == 'edit'"
          ref="modalEditView"
          :detail-type="detailType"
          :detail-modal="detailModal"
          :detail-data="detailData"
          :sel-options="selOptions"
          @submitSuccess="submitSuccess"
          @closeModel="closeModel"
        >
        </edit-view>
        <check-view
          v-else-if="detailType == 'check'"
          :detail-modal="detailModal"
          :detail-data="detailData"
          :is-encry="hiddenNumberBol"
          :encry-list="encryList"
          :encry-func="encryData"
          @submitSuccess="submitSuccess"
          @closeModel="closeModel"
        ></check-view>
      </template>
    </RModal>
  </div>
</template>

<script>
import RModal from "@/components/common/RModal";
import RTable from "@/components/common/RTable";
import tableMix from "@/components/common/tableListMixin.js";
import checkMix from "@/components/common/checkAll.js";
import detailView from "./detailView";
import editView from "./editView";
import checkView from "./checkView";

export default {
  name: "baseInfoManagerMgmt",
  mixins: [tableMix, checkMix],
  components: { RTable, detailView, RModal, editView, checkView },
  data() {
    return {
      searchKey: 'realManagerName',
      searchValue: '',

      perms: [],
      userInfo: {},
      // noCheckFunc: false, // 没有审核流程
      totalCount: 0, // 统计得到的全部数据

      curActiveStatus: "2",
      managerStatusList: [
        { label: "已通过", name: "2", originLabel: "已通过", statistics: "passCount", },
        { label: "审核中", name: "1", originLabel: "审核中", statistics: "needAuditCount", },
        { label: "未通过", name: "3", originLabel: "未通过", statistics: "noPassCount", },
        { label: "已注销", name: "4", originLabel: "已注销", statistics: "cancelCount", },
      ],
      curActiveType: '',
      managerTypeList: [
        { id: "", type: "all", label: "全部", text: "全部", },
        { id: "2", type: "org", label: "单位", text: "单位", children: [], },
        { id: "1", type: "person", label: "个人", text: "个人", },
      ],

      detailModal: false,
      detailType: "show",
      detailData: {},
      tableVarity: "baseinfo_manager_table",
      tableColumn: [],
      tableData: [],
      selOptions: {
        realManagerCountry: [],
        realManagerCertType: [],
        corporationCountry: [],
        corporationCertType: [],
      },
      options: {
        multiSelect: true, // 多选
        serialNum: false, // 显示序号
        loading: false, // 加载中状态
        initTable: true, // 是否一挂载就加载数据
        mutiSelect: true,
        selection: [],
      },
      filters: { page: 1 },
      pagination: {
        total: 0,
        pageIndex: 1,
        pageSize: 20,
      },
      hiddenNumberBol: true,

      /**
       * 字段的加密形式
       * pre: 字符串的前面保留几位原始数据
       * star: 字符串的中间有几个 *
       * tail: 字符串后边保留几位原始数据
       * 比如手机：13112345678  { pre: 3, star: 4, tail: 4 } 为：131****5678
       */
      encryList: {
        realManagerName: { pre: 1, star: 2, tail: 0 },
        realManagerPhone: { pre: 3, star: 4, tail: 4 },
        realManagerCertCode: { pre: 6, star: 8, tail: 4 },
        companyPhone: { pre: 3, star: 4, tail: 4 },
        corporationName: { pre: 1, star: 2, tail: 0 },
        corporationPhone: { pre: 3, star: 4, tail: 4 },
        corporationCertCode: { pre: 6, star: 8, tail: 4 },
      }
    };
  },
  created() {
    this.perms =
      "perms" in localStorage && localStorage.perms !== ""
        ? JSON.parse(localStorage.perms)
        : [];
    this.userInfo = localStorage.getItem("user");
    this.userInfo = this.userInfo ? JSON.parse(this.userInfo) : {};

    this.initTableColumns();
    // this.getDictData();
  },
  mounted() {
    let curManagerPageTab = localStorage.getItem("curManagerPageTab");
    if (curManagerPageTab != null) {
      this.curActiveStatus = curManagerPageTab;
      this.$nextTick(() => {
        setTimeout(() => {
          this.getQuery();
        }, 300);
      });
    } else {
      this.getQuery();
    }
  },
  beforeRouteLeave(to, from, next) {
    clearInterval(this.statisticsTimer);
    this.statisticsTimer = null;
    next();
  },
  methods: {
    // 处理状态切换搜索
    handleSearchStatus(tab) {
      this.curActiveStatus = tab;
      localStorage.setItem("curManagerPageTab", tab); // 记录当前经营者页面选中的tab项，用途：刷新后恢复选中的tab

      this.getQuery();
    },
    // 处理类型切换搜索
    handleSearchType(type) {
      this.curActiveType = type
      this.getQuery();
    },
    // 获取字典数据
    // getDictData() {
    //   this.fetchData({ url: 'RESOURCE.GET_MULTI_LIST', method: "get", params: { types: ['country_code', 'cert_type'] } }).then((res) => {
    //     console.log(res, '================ dict');
    //   });

    //   let url = "RESOURCE.GET_MULTI_LIST";
    //   this.fetchData({
    //     url,
    //     method: "get",
    //     params: {
    //       type: "country_code",
    //       start: 0,
    //       size: 1000,
    //       toExcel: false,
    //     },
    //   }).then((res) => {
    //     this.selOptions.realManagerCountry = [...res.data];
    //     this.selOptions.corporationCountry = [...res.data];
    //   });

    //   this.fetchData({
    //     url,
    //     method: "get",
    //     params: {
    //       type: "cert_type",
    //       start: 0,
    //       size: 1000,
    //       toExcel: false,
    //     },
    //   }).then((res) => {
    //     this.selOptions.realManagerCertType = [...res.data];
    //     this.selOptions.corporationCertType = [...res.data];
    //   });
    // },
    // 查询列表数据
    getQuery() {
      this.options.loading = true;
      let params = {
        reviewStatus: this.curActiveStatus,
        manageType: this.curActiveType,
        pageNumber: this.pagination.pageIndex,
        pageSize: this.pagination.pageSize
      };
      params[this.searchKey] = this.searchValue

      let url = "MANAGER.GET_LIST";
      this.fetchData({ url, method: "get", params })
        .then((res) => {
          if (res && res.data) {
            this.tableData = res.data || [];
            this.pagination.total = Number(res.rowCount);
            this.hiddenNumberBol = true;
            this.totalCount = 0;

            // this.managerStatusList.forEach((item) => {
            //   for (let key in res) {
            //     if (item.statistics === key) {
            //       item.label = `${item.originLabel}(${res[key]})`;
            //       this.totalCount += res[key];
            //     }
            //   }
            // });
          } else {
            this.tableData = [];
            this.pagination.total = 0;
          }
        })
        .catch((err) => {
          this.$message.error(err);
          this.tableData = [];
          this.pagination.total = 0;
        })
        .finally(() => {
          this.options.loading = false;
        });
    },
    // 对数据进行加密
    encryData(text, encry) {
      if (!text) return ''
      if (!this.hiddenNumberBol) return text
      if (text.length < (encry.pre + encry.tail)) return text

      let preText = text.substr(0, encry.pre)
      if (encry.pre === 0) {
        preText = ''
      }
      let star = ''
      for (let i = 0; i < encry.star; i++) {
        star += '*'
      }
      let tailText = text.substr(-encry.tail)
      if (encry.tail === 0) {
        tailText = ''
      }
      return preText + star + tailText
    },
    // 初始化自定义表头
    initTableColumns() {
      // 需要加密的字段的加密方式
      let encryList = this.encryList

      let columns = [
        { prop: "realManagerName", label: "经营人", visible: true, minWidth: 160 },
        { prop: "managerCode", label: "经营者编码", visible: true, minWidth: 180 },
        { prop: "manageTypeName", label: "经营类别", visible: true, minWidth: 80 },
        { prop: "storeCount", label: "门店数", visible: true, minWidth: 90 },
        { prop: "roomCount", label: "房源数", visible: true, minWidth: 90 },
        { prop: "realManagerPhone", label: "联系电话", visible: true, minWidth: 130 },
        { prop: "realManagerCertCode", label: "证件号码", visible: true, minWidth: 160 },
        { prop: "createTime", label: "申报日期", visible: true, minWidth: 170 },
        { prop: "reviewTime", label: "审核日期", visible: true, minWidth: 170, },
        { prop: 'operation', align:'center',label: '操作', visible: true, minWidth: 200, isInput: false },
      ];

      columns.forEach((item) => {
        if (item.prop == "realManagerName") {
          item.render = (row, index, column) => {
            let text = this.encryData(row[column.prop], encryList.realManagerName)
            return (
              <a onClick={this.handleShowDetail.bind(this, row)}>{text}</a>
            );
          };
        } else if (item.prop == "realManagerPhone") {
          item.render = (row, index, column) => {
            let text = this.encryData(row[column.prop], encryList.realManagerPhone)
            return <span>{text}</span>
          }
        } else if (item.prop == "realManagerCertCode") {
          item.render = (row, index, column) => {
            let text = this.encryData(row[column.prop], encryList.realManagerCertCode)
            return <span>{text}</span>
          }
        }else if(item.prop=='operation'){
          //1-已预订，2-已登记，3-已入住，4-已完成，5-已取消，6-已失效。目前房东没有退房权限
          item.render =  (row, index, column)=>{
            console.log(row);
            return (
              <div class="operation">
                {row.reviewStatus == 1 && (<el-button
                  v-permission="audit"
                  style="padding: 0;"
                  type="text"
                  onClick={this.handleShowCheck.bind(this, row)}
                >审核</el-button>)}
                <el-button
                  style="padding: 0; margin-left:20px"
                  type="text"
                  onClick={this.handleCheck.bind(this, row)}
                >房源列表</el-button>
              </div>
            );
          }
        }
      });

      this.tableColumn = columns;
    },
    handleShowDetail(row) {
      this.detailData = { ...row };
      this.$nextTick(() => {
        this.detailType = "show";
        this.detailModal = true;
      });
    },
    handleEdit(detailType) {
      this.$nextTick(() => {
        this.detailType = detailType;
        this.detailModal = true;
        if (detailType == "edit" && this.options.selection.length) {
          this.detailData = { ...this.options.selection[0] };
        }
      });
    },
    // 显示审核弹框
    handleShowCheck(row) {
      if(row){
        this.detailData = JSON.parse(JSON.stringify(row));
      }else{
        this.detailData = JSON.parse(JSON.stringify(this.options.selection[0]));
      }
      this.$nextTick(() => {
        this.detailType = "check";
        this.detailModal = true;
      });
    },
    handleCheck(row){
      // 跳转房源列表
      this.$router.push({
        path: '/roomInfo',
        query: {
          managerCode: row.managerCode,
        }
      });
    },
    // 处理注销操作
    handleCancled() {
      let list = this.options.selection;
      this.$confirm(
        `确定注销选中的 ${list.length} 行数据吗？`,
        "温馨提示"
      ).then(() => {
        let count = list.length;
        this.options.selection.forEach((item) => {
          let url = "SAAS.OPRATER_CHECK";
          let param = {
            id: item.id,
            isExamine: 4,
          };
          let params = {
            params: JSON.stringify(param),
          };

          this.fetchData({ url, method: "get", params }).then((res) => {
            this.$message.success("操作成功！");
            count--;
          });
        });

        let timer = setInterval(() => {
          if (count < 1) {
            this.getQuery();
            clearInterval(timer);
          }
        }, 50);
      });
    },
    // 处理删除
    handleDelete() {
      this.deleteUrl = "SAAS.OPRATER_DELETE";
      this.handlePatchDelete(true);
    },
    submitSuccess() {
      this.detailModal = false;
      this.detailType = "";
      this.pagination.pageNumber = 1
      this.getQuery();
      this.reloadData();
    },
    closeModel() {
      this.detailModal = false;
    },
    // 切换敏感信息加密状态
    switchNumberHiddenOrShow() {
      this.hiddenNumberBol = !this.hiddenNumberBol;
    },
  },
};
</script>

<style scoped lang="less">
.manager-management{
  background-color: white;
  border-radius: 16px;
  .primary{
    background-color: #FCBF0C !important;
    color: white;
  }
  .search-field-btn {
    background-color: white;
    border: 1px solid #DCDFE6;
    border-right: none;
    border-radius: 0;
    &:first-child{
      border-radius: 4px 0 0 4px;
    }
    &:last-child{
      border-right: 1px solid #DCDFE6;
      border-radius: 0 4px 4px 0;
    }
  }
  .buttons-wrapper{
    display: inline-block;
    .el-button+.el-button {
      margin-left: 0;
    }
  }
  .operate-button{
    border-radius: 8px;
    padding: 7px 20px;
    margin-left: 8px;
    &.is-disabled {
      background-color: #fff;
      color: #000 !important;
    }
  }
}
</style>